import React from "react";
import "../App.css";
import "../styles/layout.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import InsightsCharts from "../components/InsightsCharts";
import "./Monitoring.css";
import "./Insights.css";

const Insights = () => {
  return (
    <div className="app-shell">
      <Navbar />
      <main className="app-main">
        <div className="monitoring-page">
          <div className="monitoring-card">
            <div className="monitoring-card__header">
              <div>
                <h1 className="monitoring-card__title">View Insights</h1>
                <p className="monitoring-card__subtitle">
                  Audience breakdown by IP, ISP, browser, device, country, and city
                </p>
              </div>
            </div>
            <div className="monitoring-card__body">
              <InsightsCharts />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Insights;
